import { Box, Spinner } from "@twilio-paste/core";
import { ReactElement } from "react";

export const LoadingScreen = () => (
  <FullScreenCenter>
    <Spinner size="sizeIcon110" decorative={false} title="Loading" />
  </FullScreenCenter>
);

type FullScreenCenterProps = { children: ReactElement | ReactElement[] };

export const FullScreenCenter = ({ children }: FullScreenCenterProps) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    position="absolute"
    height="100%"
    width="100%"
  >
    {children}
  </Box>
);
